module.exports = __webpack_public_path__ + "static/media/رحلات متعددة الى جبال الالب.9e00c7b9.jpg";